import { CircularProgress, Typography, Button } from '@mui/material'
import React from 'react'
import dynamic from 'next/dynamic'
import { checkUserLogin, goToLoginUrlWithRedirect } from '../../services/utils'
import { GetUserDetails } from '../../services/config'
import { AnalyticService } from '../../lib/analytics/analyticService'
import { IUserDetails } from '../../interfaces/user.interface'
import LoadingSkeletonComponent from '../../components/LoadingComponents/LoadingSkeletonComponent'
import SchoolUserParentContainerComponent from '../../containers/SchoolUser/SchoolUserParentContainerComponent'
import StudentTeacherDashboardContainer from '../../containers/SchoolUser/StudentTeacherDashboardContainer/StudentTeacherDetailsContainer'
import { ISchool } from '../../interfaces/school.interface'

const TeacherCourseList = dynamic(
  () => import('../../components/Courses/TeacherCourseList'),
  {
    ssr: false,
    loading: () => (
      <div>
        <LoadingSkeletonComponent />
      </div>
    ),
  },
)

// import StudentCourseList from "../components/StudentCourseList/StudentCourseList"

const StudentCourseList = dynamic(
  () => import('../../components/Courses/StudentCourseList'),
  {
    ssr: false,
    loading: () => (
      <div>
        <LoadingSkeletonComponent />
      </div>
    ),
  },
)

const SchoolCourseDashboardView = (props: { schoolDetails: ISchool }) => {
  const [userDetails, setUserDetails] = React.useState<null | IUserDetails>(
    null,
  )

  React.useEffect(() => {
    checkUserLogin()
    setUserDetails(GetUserDetails())
    AnalyticService.userDashboardViewed()
  }, [])

  if (!userDetails) {
    return <LoadingSkeletonComponent />
  }

  console.log('\n\n\n\n\n userDetails', userDetails)

  if (userDetails?.user_type === 'admin') {
    location.href = `school-details/${props.schoolDetails?._id}/classes`
    return (
      <div style={{ textAlign: 'center' }}>
        <CircularProgress style={{ margin: '50px auto' }} size={20} />
      </div>
    )
  }

  if (userDetails?.user_type === 'student') {
    return (
      <div>
        <SchoolUserParentContainerComponent
          fb_pixel_id={props.schoolDetails?.fb_pixels_id}
          school_id={props.schoolDetails._id}
        >
          <StudentTeacherDashboardContainer
            schoolDetails={props.schoolDetails}
            userId={userDetails._id}
            userType={userDetails?.user_type}
          >
            {/* <SchooDashboardNotificationBanner
              additionalStyles={{ maxWidth: '800px' }}
              schoolDetails={props.schoolDetails}
            /> */}

            <StudentCourseList
              school_details={props.schoolDetails}
              user_details={userDetails}
              user_type={userDetails?.user_type}
            />
          </StudentTeacherDashboardContainer>
        </SchoolUserParentContainerComponent>
      </div>
    )
  }

  if (userDetails?.user_type === 'teacher') {
    return (
      <div>
        <SchoolUserParentContainerComponent
          fb_pixel_id={props.schoolDetails?.fb_pixels_id}
          school_id={props.schoolDetails._id}
        >
          <StudentTeacherDashboardContainer
            schoolDetails={props.schoolDetails}
            userId={userDetails._id}
            userType={userDetails?.user_type}
          >
            {/* <SchooDashboardNotificationBanner
              additionalStyles={{ maxWidth: '800px' }}
              schoolDetails={props.schoolDetails}
            /> */}

            <TeacherCourseList
              school_details={props.schoolDetails}
              user_details={userDetails}
              user_type={userDetails.user_type}
            />
          </StudentTeacherDashboardContainer>
        </SchoolUserParentContainerComponent>
      </div>
    )
  }

  if (!userDetails) {
    return (
      <div>
        <Typography
          variant="h5"
          align="center"
          color={'primary'}
          style={{ marginTop: '100px' }}
        >
          <CircularProgress style={{ marginTop: '30px' }} size={20} />
          <br />
          Checking login status...
        </Typography>
        <Typography
          style={{ margin: '25px' }}
          gutterBottom={true}
          variant="body1"
          align="center"
        >
          <Button
            disableElevation={true}
            variant="outlined"
            onClick={() => {
              goToLoginUrlWithRedirect()
            }}
            style={{ margin: 'auto' }}
          >
            Go to login
          </Button>
        </Typography>
      </div>
    )
  }

  return (
    <div>
      <Typography variant="h5" align="center" style={{ marginTop: '50px' }}>
        Invalid <br />
      </Typography>
      <Typography gutterBottom={true} variant="body1" align="center">
        Reload page
        <br />
        <br />
        <Button
          disableElevation={true}
          variant="contained"
          color="primary"
          onClick={() => {
            typeof location !== 'undefined' && location.reload()
          }}
          style={{ margin: 'auto' }}
        >
          Reload
        </Button>
      </Typography>
    </div>
  )
}

export default SchoolCourseDashboardView
